var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10260",
    "data-name": "Group 10260",
    transform: "translate(-771 -567)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18970",
    "data-name": "Rectangle 18970",
    width: 50,
    height: 50,
    rx: 8,
    transform: "translate(771 567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_211723_upload_cloud_icon",
    "data-name": "211723_upload_cloud_icon",
    transform: "translate(748 514.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2842",
    "data-name": "Rectangle 2842",
    width: 1.137,
    height: 6.824,
    transform: "translate(47.355 84.101)",
    fill: "#3276cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6106",
    "data-name": "Path 6106",
    d: "M58.11,72.13c0-.085.014-.171.014-.256a8.311,8.311,0,0,0-8.3-8.274A8.213,8.213,0,0,0,42.4,68.313a4.184,4.184,0,0,0-1.905-.455,4.382,4.382,0,0,0-4.187,3.7A6.5,6.5,0,0,0,32,77.689,6.4,6.4,0,0,0,38.369,84.1H58.017a5.881,5.881,0,0,0,5.829-5.886A5.974,5.974,0,0,0,58.11,72.13Z",
    transform: "translate(0 0)",
    fill: "#3d7cc9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43655",
    "data-name": "Path 43655",
    d: "M0,20V0",
    transform: "translate(795.923 585.069)",
    fill: "none",
    stroke: "#3d7cc9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43656",
    "data-name": "Path 43656",
    d: "M0,12V0",
    transform: "translate(795.923 586.458)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43654",
    "data-name": "Path 43654",
    d: "M0-5.431,5.424,0,11-5.431",
    transform: "translate(790.5 605.325)",
    fill: "none",
    stroke: "#3d7cc9",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.0b9c2e9defed7ced85ae63045bca4857.svg";
export { ForwardRef as ReactComponent };